export const TABLET_MIN_WIDTH = 768

export const DESKTOP_MIN_WIDTH = 1025

export const MEDIUM_DESKTOP_MIN_WIDTH = 1080

export const LG_DESKTOP_MIN_WIDTH = 1280

export const MEDIUM_DESKTOP_MAX_WIDTH = 1360
